export const VIEW_FULL_PART_INFO = 1
export const VIEW_STOCK_ORDER = 2
export const EDIT_ORDER = 3;
export const VIEW_RETURN = 4;
export const EDIT_RETURN = 5;
export const CROSSHAIRS_DASHBOARD = 6;
export const CREATE_CROSSHAIRS_CLAIM = 7;
export const VIEW_PLANNERS_DASHBOARD = 8;
export const EDIT_ORDER_LINES = 10;
export const ENVIRONMENT_IDENTIFIER = 11;
